import { FragmentIcon } from '@app/modules/fragments/components/FragmentIcon';
import { ParamDrivenTabsMui } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { Page } from '../../../../../components/page/Page';
import { IfAnyVideoStation } from '../../../../../components/stations/IfAnyVideoStation';
import { AdminModule } from '../../../index';
import { AudiogramForm } from './audiogram/AudiogramForm';
import { DescriptionFootersForm } from './DescriptionFootersForm';
import { MediaWatermarkForm } from './MediaWatermarkForm';
import { TagGroupsForm } from './TagGroupsForm';

export const AdminFragmentsPage = () => {
  const { $t } = useIntl();

  const title = $t({
    id: 'admin.fragments.title',
    defaultMessage: 'Configuración de fragmentos',
  });

  const tabs = [
    {
      value: 'footers',
      label: $t({
        id: 'admin.fragments.footers',
        defaultMessage: 'Footers en descripción',
      }),
      content: <DescriptionFootersForm />,
    },
    {
      value: 'watermark',
      label: $t({
        id: 'admin.fragments.watermark',
        defaultMessage: 'Media watermark',
      }),
      content: (
        <IfAnyVideoStation>
          <MediaWatermarkForm />
        </IfAnyVideoStation>
      ),
    },
    {
      value: 'audiogram',
      label: $t({
        id: 'admin.fragments.audiogram',
        defaultMessage: 'Audiogram',
      }),
      content: <AudiogramForm />,
    },
    {
      value: 'tag-groups',
      label: $t({
        id: 'admin.fragments.tagGroups',
        defaultMessage: 'Grupos de tags',
      }),
      content: <TagGroupsForm />,
    },
  ];

  return (
    <Page data-cy="admin-youtube-screen" htmlTitle={title}>
      <Page.Header
        icon={<FragmentIcon />}
        title={title}
        breadcrumbs={<Page.ModuleBreadcrumbs module={AdminModule} />}
      />
      <Page.Content>
        <ParamDrivenTabsMui id="fragments-tabs" param="tab" tabs={tabs} />
      </Page.Content>
    </Page>
  );
};
